export default __webpack_public_path__ + "img/41e593c81ad3c91988e28419f30d5626.png";